import React, {CSSProperties} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import ServiceCenterMarketingItemsBlockData from 'app/Models/Content/ServiceCenterMarketingItemsBlockData';
import ServiceCenterMarketingitemBlockData from 'app/Models/Content/ServiceCenterMarketingitemBlockData';
import {getImageProps} from 'app/utilities/ImageProps';
import ServiceCenterMarketingitem from './ServiceCenterMarketingItem';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';

import SwiperCore, {Pagination, Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
SwiperCore.use([Pagination, Autoplay]);

const ServiceCenterMarketingItemsBlock = ({data, context}: ComponentProps<ServiceCenterMarketingItemsBlockData>) => {
  const items = data.items.expandedValue.map((item: ServiceCenterMarketingitemBlockData) => ({
    title: item.title.value,
    subtitle: item.subtitle.value,
    image: getImageProps(item.image, context),
    description: item.description.value,
    link: {
      title: item.buttonLinkTitle.value,
      href: item.buttonLink.value,
    },
  }));

  const desktopBackground = getBackgroundImageProps(data.blockBackGroundImage, context)?.style?.backgroundImage;
  const mobileBackground = getBackgroundImageProps(data.blockMobileBackGroundImage, context)?.style?.backgroundImage;

  const style = {
    '--block-mobile-background': mobileBackground ?? desktopBackground,
    '--block-desktop-background': desktopBackground,
  } as CSSProperties;

  return (
    <div className='ServiceCenterMarketingItemsBlock' style={style}>
      <Swiper pagination={{clickable: true}} autoplay={{delay: 5000}}>
        {items?.map((props, i) => (
          <SwiperSlide key={i}>
            <ServiceCenterMarketingitem {...props} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ServiceCenterMarketingItemsBlock;
